import { AnimatePresence, motion, Variant } from "framer-motion";
import React, { PropsWithChildren } from "react";

export interface ICollapsibleProps<X extends string, Y extends string> {
  className?: string;
  animate?: X | Y;
  initial?: X | Y;
  exit?: X | Y;
  variants?: Record<X | Y, Variant>;
  collapsed?: boolean;
  duration?: number;
  transitionEase?: number[];
  initialAnimatePresence?: boolean;
}

const defaultVariant = {
  open: { opacity: 1, height: "auto", overflow: "unset" },
  collapsed: { opacity: 0, height: 0, overflow: "hidden" },
};

const defaultDuration = 0.8;

const defaultTransitionEase = [0.04, 0.62, 0.23, 0.98];

export const Collapsible = <X extends string, Y extends string>(props: PropsWithChildren<ICollapsibleProps<X, Y>>) => {
  const {
    children,
    collapsed = true,
    className,
    duration = defaultDuration,
    transitionEase = defaultTransitionEase,
    animate = "open",
    initial = "collapsed",
    exit = "collapsed",
    variants = defaultVariant,
    initialAnimatePresence = false,
  } = props;

  return (
    <AnimatePresence initial={initialAnimatePresence}>
      {!collapsed && (
        <motion.section
          initial={initial}
          animate={animate}
          exit={exit}
          variants={variants}
          transition={{ duration, ease: transitionEase }}
          className={className}>
          {children}
        </motion.section>
      )}
    </AnimatePresence>
  );
};
